import { AXNUIContent } from "@iddataweb/idw-common-ui/types";
import {
    FormattedWorkflowTemplateDetails,
    WorkflowTemplateDetails
} from "@idw-types/data/workflow-template-details";
import {
    AxnAttributeTypeField,
    AxnAvailablePropertyCategory,
    AxnCompany,
    AxnIdentityProvider,
    AxnRelyingParty,
    AxnServiceOfferingDataSource
} from "@idw-types/data/reference-data/axn";
import { formatWorkflowTemplateDetailsTemplate } from "./workflow-template-details-template-formatter";
import {
    ApAssertion,
    Assertion,
    AttributeClassification,
    AttributeLabel,
    AttributeType,
    DeployedPolicyComponent,
    FallbackServiceMapping,
    RpServiceAttributeProperty,
    RpServiceAttributePropertyMap,
    ServiceOffering
} from "@idw-types/data/reference-data/generic";

export const formatWorkflowTemplateDetails = (
    workflowTemplateDetails: WorkflowTemplateDetails,
    axnIdentityProviders: Array<AxnIdentityProvider>,
    axnRelyingParties: Array<AxnRelyingParty>,
    axnCompanies: Array<AxnCompany>,
    axnAvailablePropertyCategories: Array<AxnAvailablePropertyCategory>,
    attributeTypes: Array<AttributeType>,
    attributeLabels: Array<AttributeLabel>,
    attributeClassifications: Array<AttributeClassification>,
    rpServiceAttributeProperties: Array<RpServiceAttributeProperty>,
    rpServiceAttributePropertyMaps: Array<RpServiceAttributePropertyMap>,
    axnuiContent: AXNUIContent,
    deployedPolicyComponents: Array<DeployedPolicyComponent>,
    axnAttributeTypeFields: Array<AxnAttributeTypeField>,
    serviceOfferings: Array<ServiceOffering>,
    apAssertions: Array<ApAssertion>,
    assertions: Array<Assertion>,
    serviceOfferingDataSources: Array<AxnServiceOfferingDataSource>,
    fallbackServiceMappings: Array<FallbackServiceMapping>
): FormattedWorkflowTemplateDetails => {
    const organization = axnCompanies.find(company => company.id === workflowTemplateDetails.organizationID);

    const formattedTemplate = formatWorkflowTemplateDetailsTemplate(
        workflowTemplateDetails.template,
        axnIdentityProviders,
        axnRelyingParties,
        axnCompanies,
        axnAvailablePropertyCategories,
        attributeTypes,
        attributeLabels,
        attributeClassifications,
        rpServiceAttributeProperties,
        rpServiceAttributePropertyMaps,
        axnuiContent,
        deployedPolicyComponents,
        axnAttributeTypeFields,
        serviceOfferings,
        apAssertions,
        assertions,
        serviceOfferingDataSources,
        fallbackServiceMappings
    );

    return {
        ...workflowTemplateDetails,
        organization,
        template: formattedTemplate,
        templateString: workflowTemplateDetails.template
    };
};